import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 100 100",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      x: "50",
      y: "50",
      width: "50",
      height: "50",
      fill: "#FFD45B"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "50",
      cy: "50",
      r: "50",
      fill: "#161616"
    }, null, -1)
  ]))]))
}
export default { render: render }